<template>
  <div class="upgrade">
     <div class="con">
        <img src="@/assets/img/mine/newlogo.png" class="imgs">
        <p class="txt">在鸿学生终端</p>
        <p class="gray note">固件版本：{{detail.moduleVersion}}</p>
        <div class="note1">
          <template v-if="detail.upgradeStatus==1"><!--无需升级-->
             <p class='status'>当前已是最新版本</p>
          </template>
          <template v-else-if="detail.upgradeStatus==2"><!--待升级-->
             <p class='status'>检测到固件有新版本，是否升级？</p>
             <div class="white_bgc">
                 <div class='texts' v-html="detail.upgradeCopy"></div>
             </div>
             <div class='btn-primary' @click="handleClick">确认升级</div>
          </template>
          <template v-else-if="detail.upgradeStatus==3"><!--升级中-->
            <p class='status'>设备将在凌晨2点-4点尝试自动升级固件，在此期间请保持设备开机、电量充足</p>
          </template>
         
          <template v-else-if="detail.upgradeStatus>3"><!--升级失败-->
            <div class="font16 red">升级失败</div>
            <p class=' gray font14' style="text-align:left">失败原因可能是：设备关机、电量不足、网络异常、存储不够等。</p>
            <div class="white_bgc" style="margin-bottom: 0.12rem;">
                <div class='texts' v-html="detail.upgradeCopy"></div>
            </div>
            <div class='btn-primary' @click="handleClick">重新升级</div>
          </template>
        </div>
        
     </div>
     <div class='loading' v-if="loading"><van-loading type="spinner" color="#fff" /></div>

     <van-popup v-model="show" closeable close-icon="close" :style="{ borderRadius: '10px',width:'60%',padding:'.25rem 0px .1rem' }">
       <div class='texts' v-html='detail.upgradeCopy'></div>
     </van-popup>
  </div>
</template>
<script>
  import {queryByStudentId,upgrade} from '@/api/api.mine.js';
  export default {
    data() {
      return {
        detail:'',
        loading:false,
        show:false,
      }
    },
    created(){
      this.getInfo(); 
    },  
    methods: {
      getInfo(){
        queryByStudentId({studentId:this.loginUser.studentId}).then((data)=>{
 //  data.result={upgradeStatus:4,errorLog:'失败原因可能是：设备关机、电量不足、网络异常、存储不够等。',moduleVersion:'V1.1.0',upgradeCopy:'最新版本升级：\n1.优化了ui\n2.增加了表情包\n3.修改了bug\n4.增加了趣味性\n5.功能优化\n6.ui优化\n7.当前版本1.1.0.4',}
          if(data.result){
            this.detail=data.result;
          }
        })
      },
      handleClick(){ 
        let msg='设备将在凌晨2点-4点尝试自动升级固件，在此期间请保持设备开机、电量充足';
        this.$dialog.confirm({
            message: msg,
            confirmButtonColor:'#2403df',
            confirmButtonText:'确定'
         }).then(() => {
           this.loading=true;
           this.changeUpdate();
         }).catch(()=>{

         });
        
      },
      changeUpdate(){
        this.loading=true;
        upgrade({
              batchDeviceIds:this.detail.batchDeviceId,
              studentId:this.loginUser.studentId
            }).then(()=>{
              this.loading=false;
              localStorage.removeItem('showUpgrade');
              this.getInfo();
            })
      }
    },
  }
</script>
<style lang="scss" >
.upgrade{
  height: 100%;
  // background: url(../../assets/img/mine/my3.png) no-repeat left top;
  // background-size: 100%;
  // padding:.12rem .15rem;
  .title{
    color:#fff;
    font-size:.19rem;
    text-align: center;
    margin-bottom: .2rem;
    padding-top: .1rem;
  }
  .con{
    border-radius:10px;
    padding:.2rem .12rem;
    text-align: center;
    font-size: .15rem;
    .imgs{
      margin-top: .5rem;
      margin-bottom: .08rem;
      width: .8rem;
      height: .8rem;
    }
    .txt{
      font-size: .19rem;
      padding-bottom: .08rem;
      font-weight: 550;
    }
    .note1{
      margin-top: .4rem;
      line-height: .22rem;
      font-size: .15rem;
    }
    .blue{
      color:#3b88fa;
      font-size: .13rem;
      padding-top:5px;
      margin-bottom: .2rem;
    }
    .tit{
      margin-top: .2rem;
      line-height: .26rem;
      font-size: .12rem;
    }
  }
  .texts{
    padding:0rem .15rem;
    line-height: .25rem;
    max-height: 200px;
    font-size: .15rem;
    overflow: hidden;
    overflow-y: auto;
    white-space: pre-line;
    position: relative;
  }
  .van-popup__close-icon--top-right{
    top:6px;
    right: 6px;
  }
  .white_bgc{
    margin-top: 0.12rem;
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
    padding: 0.12rem;
    text-align: left;
    .up_title{
      font-size: 0.14rem;
      font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
      font-weight: 400;
      color: rgba(0,0,0,0.9);
    }
  }
  .red{
    color:#E84026;
  }
}

</style>